import React from 'react';
import PropTypes from 'prop-types';
import BookingStep from './BookingStep';
import PaymentSelect from './PaymentSelect';
import RadioButtonInput from './formComponents/RadioButtonInput';
import VoucherEntryContainer from '../containers/VoucherEntryContainer';
import PaymentHOC from '../hoc/PaymentHOC';
import Translate from './Translate';
import translator from '../translations/drupalTranslator';
import PaymentRatesList from './PaymentRatesList';
import { actionstype, errorstype } from '../types/importtypes';
import { prepaidVoucherExist } from '../api/utils';
import TimeoutModal from "./TimeoutModal";

const PaymentSectionRates = ({
  actions,
  appearance,
  errors,
  order,
  rental,
  paymentOptionSupportsVoucher,
  selectPaymentOption,
  selectPaymentType,
  stepIndex,
  stepTotal,
  validate,
}) => {
  const radioButtonOnChange = (name, value) => {
    selectPaymentType(!!parseInt(value,
      10));
  };

  let voucherEntry;
  if (!!order.payment && appearance.voucherEnabledForMarketBrand) {
    voucherEntry = (
      <VoucherEntryContainer
        actions={actions}
        errors={errors}
        paymentSelected={!!order.payment.paymentOptionSelected}
        prepaidVoucher={order.bookingPrice.prepaidVoucher}salesChannel={order.salesChannel}
        voucher={order.payment.voucher}
        voucherSupported={!!paymentOptionSupportsVoucher(order.payment)}
        timeoutModal={rental.timeoutModal}
      />
    );
  }

  const rates = order.bookingPrice.rates.map(rate => ({...rate}));
  if (order.bookingPrice.rates.length > 1) {
    rates[1].description = translator.translate('The 2. rate will be deducted automatically from you account on the due date.');
  }

  return (
    <section
      className="booking-step booking-payment card"
      id="booking-payment"
    >
      <div className="booking-step__inner">
        <div className="booking-step__inner2">
          <h2 className="card__header">
            <span className="card__header-prefix">
              {stepIndex}
              /
              {stepTotal}
            </span>
            <Translate content="Payment"/>
          </h2>
          <section id="payment-form">
            <div className="card__body card__body--top">
              <PaymentSelect
                errors={errors.payment}
                payment={order.payment}
                rates={order.bookingPrice.rates}
                selectPaymentOption={selectPaymentOption}
                validate={validate}
                voucher={voucherEntry}
              />
            </div>
            {(order.bookingPrice.rates.length !== 1 && !prepaidVoucherExist(order.bookingPrice.prepaidVoucher)) ? (
              <div className="card__body">
                <div className="radio">
                  <RadioButtonInput
                    checked={order.payment.singleRate === true}
                    id="payment-one-payment"
                    name="payment"
                    onChange={radioButtonOnChange}
                    value={1}
                  />
                  <label htmlFor="payment-one-payment">
                    <Translate content="Pay the full amount now"/>
                  </label>
                </div>
                <div className="radio">
                  <RadioButtonInput
                    checked={order.payment.singleRate === false}
                    id="payment-two-payments"
                    name="payment"
                    onChange={radioButtonOnChange}
                    value={0}
                  />
                  <label htmlFor="payment-two-payments">
                    <Translate content="Pay the amount in two installments"/>
                  </label>
                </div>
                {!order.payment.singleRate ? (
                  <div className="radio-content">
                    <PaymentRatesList rates={rates}/>
                  </div>
                ) : null}
              </div>
            ) : null}
          </section>
        </div>
      </div>
    </section>
  );
};

PaymentSectionRates.PropTypes = {
  actions: actionstype,
  appearance: PropTypes.object.isRequired,
  errors: errorstype,
  order: PropTypes.object.isRequired,
  rental: PropTypes.object.isRequired,
  paymentOptionSupportsVoucher: PropTypes.func.isRequired,
  selectPaymentOption: PropTypes.func.isRequired,
  selectPaymentType: PropTypes.func.isRequired,
  stepIndex: PropTypes.number.isRequired,
  stepTotal: PropTypes.number.isRequired,
  validate: PropTypes.func,
};

export default PaymentHOC(BookingStep(PaymentSectionRates));
